// ============================================
// COMPLIANCE & DOCUMENTS TEST DATA
// ============================================

// Document categories
export const documentCategories = [
  { id: 'licenses', name: 'Licenses & Permits', nameNo: 'Lisenser og tillatelser' },
  { id: 'certifications', name: 'Certifications', nameNo: 'Sertifiseringer' },
  { id: 'policies', name: 'Policies & Procedures', nameNo: 'Retningslinjer og prosedyrer' },
  { id: 'contracts', name: 'Contracts', nameNo: 'Kontrakter' },
  { id: 'insurance', name: 'Insurance', nameNo: 'Forsikring' },
  { id: 'health-safety', name: 'Health & Safety', nameNo: 'HMS' },
  { id: 'financial', name: 'Financial', nameNo: 'Økonomi' },
  { id: 'hr', name: 'HR Documents', nameNo: 'HR-dokumenter' },
];

// Licenses and permits
export const licenses = [
  {
    id: 'lic-001',
    outletId: 'no-sorengkaia',
    type: 'licenses',
    name: 'Alcohol License',
    nameNo: 'Skjenkebevilling',
    issuingAuthority: 'Oslo Kommune',
    licenseNumber: 'SKJ-2024-1234',
    issueDate: '2024-01-01',
    expiryDate: '2025-12-31',
    status: 'active',
    renewalRequired: true,
    renewalLeadDays: 90,
    documentUrl: '/docs/lic-001.pdf',
    notes: 'Covers all alcohol types. Max capacity 135.',
  },
  {
    id: 'lic-002',
    outletId: 'no-sorengkaia',
    type: 'licenses',
    name: 'Food Service License',
    nameNo: 'Serveringsbevilling',
    issuingAuthority: 'Mattilsynet',
    licenseNumber: 'MAT-2022-5678',
    issueDate: '2022-05-15',
    expiryDate: null, // No expiry
    status: 'active',
    renewalRequired: false,
    documentUrl: '/docs/lic-002.pdf',
    notes: 'Permanent license. Annual inspection required.',
  },
  {
    id: 'lic-003',
    outletId: 'no-sorengkaia',
    type: 'certifications',
    name: 'Food Hygiene Certificate',
    nameNo: 'Hygienesertifikat',
    issuingAuthority: 'Mattilsynet',
    licenseNumber: 'HYG-2024-9012',
    issueDate: '2024-03-01',
    expiryDate: '2025-02-28',
    status: 'expiring-soon',
    renewalRequired: true,
    renewalLeadDays: 60,
    documentUrl: '/docs/lic-003.pdf',
    notes: 'Renewal inspection scheduled for Feb 2025.',
  },
  {
    id: 'lic-004',
    outletId: 'no-sorengkaia',
    type: 'certifications',
    name: 'Fire Safety Certificate',
    nameNo: 'Brannsertifikat',
    issuingAuthority: 'Oslo Brann- og redningsetat',
    licenseNumber: 'BRANN-2023-3456',
    issueDate: '2023-06-15',
    expiryDate: '2025-06-14',
    status: 'active',
    renewalRequired: true,
    renewalLeadDays: 90,
    documentUrl: '/docs/lic-004.pdf',
  },
  {
    id: 'lic-005',
    outletId: 'no-sorengkaia',
    type: 'insurance',
    name: 'Business Insurance',
    nameNo: 'Bedriftsforsikring',
    issuingAuthority: 'If Forsikring',
    licenseNumber: 'POL-2024-7890',
    issueDate: '2024-01-01',
    expiryDate: '2024-12-31',
    status: 'expired',
    renewalRequired: true,
    renewalLeadDays: 30,
    documentUrl: '/docs/lic-005.pdf',
    notes: 'URGENT: Renewal pending. New policy received.',
  },
  {
    id: 'lic-006',
    outletId: 'no-sorengkaia',
    type: 'contracts',
    name: 'Lease Agreement',
    nameNo: 'Leieavtale',
    issuingAuthority: 'Sørengkaia Eiendom AS',
    licenseNumber: 'LEASE-2018-001',
    issueDate: '2018-05-01',
    expiryDate: '2028-04-30',
    status: 'active',
    renewalRequired: true,
    renewalLeadDays: 180,
    documentUrl: '/docs/lic-006.pdf',
    notes: '10-year lease with 5-year renewal option.',
  },

  // Frogner licenses
  {
    id: 'lic-010',
    outletId: 'no-frogner',
    type: 'licenses',
    name: 'Alcohol License',
    nameNo: 'Skjenkebevilling',
    issuingAuthority: 'Oslo Kommune',
    licenseNumber: 'SKJ-2024-5678',
    issueDate: '2024-01-01',
    expiryDate: '2025-12-31',
    status: 'active',
    renewalRequired: true,
    renewalLeadDays: 90,
    documentUrl: '/docs/lic-010.pdf',
  },

  // Sweden licenses
  {
    id: 'lic-020',
    outletId: 'se-hammarby',
    type: 'licenses',
    name: 'Alcohol License',
    nameNo: 'Serveringstillstånd',
    issuingAuthority: 'Stockholm Stad',
    licenseNumber: 'SERV-2024-1234',
    issueDate: '2024-01-01',
    expiryDate: '2025-12-31',
    status: 'active',
    renewalRequired: true,
    renewalLeadDays: 90,
    documentUrl: '/docs/lic-020.pdf',
  },
];

// Compliance tasks / checklist
export const complianceTasks = [
  {
    id: 'task-001',
    outletId: 'no-sorengkaia',
    category: 'health-safety',
    name: 'Daily Temperature Log',
    nameNo: 'Daglig temperaturlogg',
    frequency: 'daily',
    lastCompleted: '2025-01-27T08:00:00Z',
    nextDue: '2025-01-28T08:00:00Z',
    assignedTo: 'emp-004',
    status: 'completed',
  },
  {
    id: 'task-002',
    outletId: 'no-sorengkaia',
    category: 'health-safety',
    name: 'Weekly Deep Clean',
    nameNo: 'Ukentlig grundig rengjøring',
    frequency: 'weekly',
    lastCompleted: '2025-01-20T06:00:00Z',
    nextDue: '2025-01-27T06:00:00Z',
    assignedTo: 'emp-003',
    status: 'due-today',
  },
  {
    id: 'task-003',
    outletId: 'no-sorengkaia',
    category: 'health-safety',
    name: 'Fire Extinguisher Check',
    nameNo: 'Kontroll av brannslukker',
    frequency: 'monthly',
    lastCompleted: '2024-12-27T10:00:00Z',
    nextDue: '2025-01-27T10:00:00Z',
    assignedTo: 'emp-003',
    status: 'due-today',
  },
  {
    id: 'task-004',
    outletId: 'no-sorengkaia',
    category: 'health-safety',
    name: 'Pest Control Inspection',
    nameNo: 'Skadedyrkontroll',
    frequency: 'quarterly',
    lastCompleted: '2024-10-15T09:00:00Z',
    nextDue: '2025-01-15T09:00:00Z',
    assignedTo: null,
    status: 'overdue',
    vendor: 'Anticimex',
  },
];

// Audit trail
export const auditLog = [
  {
    id: 'audit-001',
    timestamp: '2025-01-27T14:32:15Z',
    userId: 'emp-002',
    userName: 'Line Johansen',
    action: 'CREATE',
    module: 'POS',
    resource: 'Order #1247',
    details: 'Created new order for Table T3',
    outletId: 'no-sorengkaia',
    ipAddress: '192.168.1.45',
  },
  {
    id: 'audit-002',
    timestamp: '2025-01-27T14:28:42Z',
    userId: 'emp-004',
    userName: 'Rajesh Kumar',
    action: 'UPDATE',
    module: 'Inventory',
    resource: 'Stock Level',
    details: 'Updated Chicken Tikka stock: 5kg → 2.5kg',
    outletId: 'no-sorengkaia',
    ipAddress: '192.168.1.48',
  },
  {
    id: 'audit-003',
    timestamp: '2025-01-27T14:15:00Z',
    userId: 'emp-001',
    userName: 'Erik Andersen',
    action: 'APPROVE',
    module: 'Approvals',
    resource: 'EXP-2025-040',
    details: 'Approved expense claim kr 3,200 - Marketing',
    outletId: 'no-sorengkaia',
    ipAddress: '192.168.1.1',
  },
  {
    id: 'audit-004',
    timestamp: '2025-01-27T13:45:22Z',
    userId: 'emp-001',
    userName: 'Erik Andersen',
    action: 'UPDATE',
    module: 'Menu',
    resource: 'Price Update',
    details: 'Updated Chicken Tikka Masala price: kr 179 → kr 189',
    outletId: 'no-sorengkaia',
    ipAddress: '192.168.1.1',
  },
  {
    id: 'audit-005',
    timestamp: '2025-01-27T10:30:00Z',
    userId: 'emp-002',
    userName: 'Line Johansen',
    action: 'LOGIN',
    module: 'Auth',
    resource: 'User Session',
    details: 'User logged in via Google SSO',
    outletId: 'no-sorengkaia',
    ipAddress: '192.168.1.45',
  },
];

// Helper functions
export const getLicensesByOutlet = (outletId) => licenses.filter(l => l.outletId === outletId);
export const getExpiringLicenses = (days = 30) => {
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() + days);
  return licenses.filter(l => {
    if (!l.expiryDate) return false;
    const expiry = new Date(l.expiryDate);
    return expiry <= cutoff && l.status !== 'expired';
  });
};
export const getExpiredLicenses = () => licenses.filter(l => l.status === 'expired');
export const getOverdueTasks = () => complianceTasks.filter(t => t.status === 'overdue');
export const getAuditLogByOutlet = (outletId) => auditLog.filter(a => a.outletId === outletId);
